
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, DollarSign, Heart, BookOpen, Smile, Briefcase } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { cn } from '@/lib/utils';

/** Mobile hamburger navigation with active state highlighting */
const MobileNavigation: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const categories = [
    { name: 'Financial Tools', path: '/calculators/financial-tools', icon: <DollarSign className="h-5 w-5 text-finance" />, color: 'text-finance' },
    { name: 'Health & Wellness', path: '/calculators/health-wellness', icon: <Heart className="h-5 w-5 text-health" />, color: 'text-health' },
    { name: 'Math & Education', path: '/calculators/education', icon: <BookOpen className="h-5 w-5 text-education" />, color: 'text-education' },
    { name: 'Lifestyle & Fun', path: '/calculators/lifestyle', icon: <Smile className="h-5 w-5 text-lifestyle" />, color: 'text-lifestyle' },
    { name: 'Professional Tools', path: '/calculators/professional-tools', icon: <Briefcase className="h-5 w-5 text-professional" />, color: 'text-professional' },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Menu" className="md:hidden">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      
      <SheetContent side="left" className="w-[280px] sm:w-[350px]">
        <div className="flex flex-col gap-6 py-4">
          <div className="flex items-center justify-between">
            <p className="text-lg font-medium">Categories</p>
            <Button variant="ghost" size="sm" onClick={() => setOpen(false)}>
              <X className="h-4 w-4" />
            </Button>
          </div>
          
          <nav className="flex flex-col space-y-1">
            {categories.map((category) => {
              const isActive = location.pathname.startsWith(category.path);
              return (
                <Link
                  key={category.path}
                  to={category.path}
                  className={cn(
                    "flex items-center gap-3 px-4 py-3 rounded-md hover:bg-accent",
                    isActive && "bg-accent text-accent-foreground font-semibold"
                  )}
                  onClick={() => setOpen(false)}
                >
                  {category.icon}
                  <span className={cn(category.color, "font-medium", isActive && "font-semibold")}>{category.name}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNavigation;
